module.exports = __webpack_public_path__ + "static/media/Success.ba79f555.svg";